import PropTypes from 'prop-types';
import { Parallax } from 'react-scroll-parallax';

import { CtfMedia } from '@/molecules/Media/index';

function FloatingAsset({ assets, entries, fields }) {
  const { asset, position, offsetTop } = fields;

  return (
    <div className="aaco-floating-asset relative">
      <div
        className={`absolute right z-40 ${
          position === 'Left' ? 'left-0 ' : 'right-0'
        } ${offsetTop ? '-top-80 md:-top-72' : '-top-40 md:-top-36'}`}
      >
        <Parallax speed={-4}>
          <CtfMedia
            field={asset}
            assets={assets}
            entries={entries}
            style={`w-1/4 h-1/4 md:w-[250px] md:h-auto  ${
              position === 'Right' ? 'float-right' : ''
            }`}
          />
        </Parallax>
      </div>
    </div>
  );
}

FloatingAsset.propTypes = {
  assets: PropTypes.array,
  entries: PropTypes.array,
  fields: PropTypes.object,
};

FloatingAsset.defaultProps = {
  assets: [],
  entries: [],
  fields: null,
};

export default FloatingAsset;
